export interface UploadStatusLabels {
  uploaded: string;
  uploading: string;
  failed: string;
  pending: string;
}

export function getUploadStatusText(
  status: string,
  labels: UploadStatusLabels,
): string {
  switch (status) {
    case "completed":
      return labels.uploaded;
    case "uploading":
      return labels.uploading;
    case "failed":
      return labels.failed;
    default:
      return labels.pending;
  }
}
